module.exports = __webpack_public_path__ + "img/icon-easy.b57dffd3.svg";